import { generateGuid, detectDevice, getUtmData, getUtcTimestamp, getScrollPercentage, getUtcTimestampNumeric } from "./helpers";
import { convertStringToNumber, getDomain, validateWithBotd, getHref, getTimestampRange } from "./helpers";

import { UserSessionProvider, UserStateProvider, UserActionPageDataProvider, UserConversionProvider } from "./providers";
import { UserActionCache, UserActionAnalyticsCache, UserPredictionCache} from "./caches";

import { UserAction, UserActionType, UserPush, UserSession, UserActionAnalytics, UserPrediction } from "./models";
import { BackendService, DataLayerService } from "./api";
import { Logger } from "./logger";
import { SignalService } from "./signals";
import { GAService } from "./ga"

export async function aiInit()
{

    let userState = UserStateProvider.get();
    let isFcAvailable = UserStateProvider.isFcSessionDataAvailable();
    let userSession = UserSessionProvider.get();

    if(userState.userId == null || userState.userId.includes(".") == false)
    {
        userState.userId = GAService.getGaUserId();
        UserStateProvider.set(userState);
    }

    if(userState.domain == null)
    {
        userState.domain = getDomain();
        UserStateProvider.set(userState);
    }

    if(userSession == null)
    {
        userSession = aiCreateUserSession();
        userState.lastSessionTimestamp = userState.currentSessionTimestamp;
        userState.currentSessionTimestamp = getUtcTimestamp();
        UserStateProvider.set(userState);
    }
    if(userSession.id.includes('.') == false)
    {
        userSession.id = GAService.getGaSessionId();
        UserSessionProvider.set(userSession);
    }

    if(isFcAvailable == false)
    {
        let browserType = detectDevice();
        let [source, medium, campaign] = getUtmData();
        userState.userBrowserType = browserType;

        userState.fcSource = source;
        userState.fcCampaign = campaign;
        userState.fcMedium = medium;
        userState.fcTimestampNumeric = userSession.timestampNumeric;
        userState.fcTimestamp = userSession.timestamp;
        userState.fcSessionId = userSession.id;
        
        userState.fcSessionWeightedDecile = 1;
        userState.fcSessionUserType = "low";
        UserStateProvider.set(userState);
    }

    if(userState.isBot == null)
    {
        userState.isBot = await validateWithBotd();
        UserStateProvider.set(userState);
    }

    if(userState.isDataLayerInitialized == false)
    {
        aiPushPrediction("page_view");
        userState.isDataLayerInitialized = true;
        UserStateProvider.set(userState);
    }
}

export function aiCreateUserSession()
{
    let session = new UserSession();
    let [source, medium, campaign] = getUtmData();

    session.id = GAService.getGaSessionId();
    session.source = source;
    session.medium = medium;
    session.campaign = campaign;
    session.timestamp = getUtcTimestamp();
    session.timestampNumeric = getUtcTimestampNumeric();

    UserSessionProvider.set(session);
    return session;
}

export function aiValidateUserSession()
{
    let userState = UserStateProvider.get();
    let currentTimestamp = getUtcTimestamp();
    let difference = getTimestampRange(currentTimestamp, userState.lastActionTimestamp);
    if(difference > 60*30)
    {
        let userSession = aiCreateUserSession();
        userState.lastSessionTimestamp = userState.currentSessionTimestamp;
        userState.currentSessionTimestamp = getUtcTimestamp();
    }
    userState.lastActionTimestamp = currentTimestamp;
    UserStateProvider.set(userState);
}

export function aiCreateUserAction(event, isConversion, conversionValue)
{
    aiValidateUserSession();

    let userAction = new UserAction();

    userAction.id = generateGuid();
    userAction.href = getHref();
    userAction.timestamp = getUtcTimestamp();
    userAction.timestampNumeric = getUtcTimestampNumeric();
    userAction.conversionValue = conversionValue;

    let pageData = UserActionPageDataProvider.get(userAction.href);

    try
    {
        userAction.targetId = event.target.id != undefined ? event.target.id : 'none';
        if(userAction.targetId == "")
        {
            userAction.targetId = "none";
        }
    }
    catch(ex)
    {
        userAction.targetId = 'none';
    }
    try
    {
        userAction.targetName = event.target.nodeName != undefined ? event.target.nodeName : 'none';
        if(userAction.targetName == "")
        {
            userAction.targetName = "none";
        }
    }
    catch(ex)
    {
        userAction.targetName = 'none';
    }
    try
    {
        userAction.targetCss = event.target.className != undefined ? event.target.className : 'none';
        if(userAction.targetCss == "")
        {
            userAction.targetCss = "none";
        }
    }
    catch(ex)
    {
        userAction.targetCss = 'none';
    }
    try
    {
        userAction.targetValue = event.target.innerText != undefined ? event.target.innerText : 'none';
        if(userAction.targetValue == "")
        {
            userAction.targetValue = "none";
        }
    }
    catch(ex)
    {
        userAction.targetValue = 'none';
    }    
    userAction.scrollPosition = getScrollPercentage();
    userAction.userActionType = UserActionType.PageView;

    if(event.type == "click")
    {
        userAction.userActionType = UserActionType.Click;
    }
    try
    {
        if(event.target.tagName == undefined)
        {
            userAction.userActionType = UserActionType.PageView;
        }
        if(event.target.tagName == "BUTTON")
        {
            userAction.userActionType = UserActionType.ButtonClick;
        }
        if(event.target.tagName == "A")
        {
            userAction.userActionType = UserActionType.LinkClick;
        }
    }
    catch(ex)
    {
        
    }
    
    if(event.type == "DOMContentLoaded" || event.type == "load")
    {
        userAction.userActionType = UserActionType.PageView;
    }
    if(event.type == "scroll")
    {
        userAction.userActionType = UserActionType.Scroll;
    }
    if(event.type == "submit")
    {
        userAction.userActionType = UserActionType.FormSubmit;
    }
    if(isConversion == true)
    {
        userAction.userActionType = UserActionType.Conversion;
    }

    if(userAction.userActionType == UserActionType.FormSubmit || 
        userAction.userActionType == UserActionType.LinkClick ||
        userAction.userActionType ==  UserActionType.Click || 
        userAction.userActionType ==  UserActionType.LinkClick)
        {
            pageData.clicksCount += 1;
        }
    
    if(userAction.scrollPosition > convertStringToNumber(pageData.scroll))
    {
        pageData.scroll = userAction.scrollPosition;
        UserActionPageDataProvider.set(pageData);
        UserActionCache.set(userAction);
    }
    else
    {
        if(userAction.userActionType != "scroll")
        {
            UserActionPageDataProvider.set(pageData);
            UserActionCache.set(userAction);
        }
    }
}

export function aiProcessConversion()
{
    for(var index in dataLayer)
    {
      try
      {
        var item = dataLayer[index]
        if(!('event' in item )){
          continue;
        }
        var eventValue = item['event'].toLowerCase()
        if (!eventValue.includes('ai_conversion'))
        {
          continue;
        }
        var conversionValue = "0"
        try
        {
            conversionValue = "" + item['value']
        }
        catch(ex)
        {
            console.log(ex);
        }
        uniqueId = item['gtm.uniqueEventId'];
        let exist = UserConversionProvider.get(uniqueId);
        if(exist == false)
        {
            aiCreateUserAction({"type":"conversion"}, true, convertStringToNumber(conversionValue));
            UserConversionProvider.set(uniqueId);
            aiPushPrediction("conversion");
        }
      }
      catch(ex)
      {
        console.log(ex);
      }
    }
}

export function aiCreateUserActionAnalytics(userAction)
{
    let userActionAnalytics = new UserActionAnalytics();
    let session = UserSessionProvider.get();
    let userState = UserStateProvider.get();
    let pageData = UserActionPageDataProvider.get(userAction.href);

    if(session == null)
    {
        userSession = aiCreateUserSession();
        userState.lastSessionTimestamp = userState.currentSessionTimestamp;
        userState.currentSessionTimestamp = getUtcTimestamp();
        UserStateProvider.set(userState);
        session = UserSessionProvider.get();
    }

    if(userState.userId == null || userState.userId.includes(".") == false)
    {
        userState.userId = GAService.getGaUserId();
        UserStateProvider.set(userState);
    }
    if(session.id == null || session.id.includes(".") == false)
    {
        session.id = GAService.getGaSessionId();
        UserSessionProvider.set(session);
    }

    userActionAnalytics.id = generateGuid();
    userActionAnalytics.userActionType = userAction.userActionType;

    if(userAction.userActionType == UserActionType.Conversion)
    {   
        userActionAnalytics.previousUserType = userState.userType;
        userActionAnalytics.nextUserType = UserActionType.Conversion;
        userState.userType = UserActionType.Conversion;
        if(userState.fcSessionId == session.id)
        {
            userState.fcSessionUserType = UserActionType.Conversion;
            userActionAnalytics.fcSessionUserType = UserActionType.Conversion;
        }
        else
        {
            userActionAnalytics.fcSessionUserType = userState.fcSessionUserType;
        }
        userState.conversionCount += 1;
        userState.isConversion = true;
        userState.lastConversionTimestamp = getUtcTimestamp();
        UserStateProvider.set(userState);
    }
    else
    {
        userActionAnalytics.previousUserType = userState.previousUserType;
        userActionAnalytics.nextUserType = userState.userType;
        userActionAnalytics.fcSessionUserType = userState.fcSessionUserType;
    }
    userActionAnalytics.href = userAction.href;
    userActionAnalytics.scrollPosition = convertStringToNumber(userAction.scrollPosition);
    userActionAnalytics.conversionValue = convertStringToNumber(userAction.conversionValue);

    userActionAnalytics.signalUrl = SignalService.getSignalUrl();
    userActionAnalytics.signalType = SignalService.getSignalType(userActionAnalytics.signalUrl, userActionAnalytics.targetId,
         userActionAnalytics.targetName, userActionAnalytics.targetCss, userActionAnalytics.userActionType);

    userActionAnalytics.sessionId = session.id;
    userActionAnalytics.sessionFcSource = session.source;
    userActionAnalytics.sessionFcMedium = session.medium;
    userActionAnalytics.sessionFcCampaign = session.campaign;
    userActionAnalytics.conversionCount = userState.conversionCount;


    if(userState.lastSessionTimestamp == null)
    {
        userActionAnalytics.lastSessionTimestamp = "none";
    }
    else
    {
        userActionAnalytics.lastSessionTimestamp = userState.lastSessionTimestamp;
    }

    userActionAnalytics.userId = userState.userId;
    userActionAnalytics.domain = userState.domain;

    userActionAnalytics.nextWeightedDecile = userState.weightedDecile;
    userActionAnalytics.nextRgDecile = userState.rgDecile;
    userActionAnalytics.nextStDecile = userState.stDecile;
    userActionAnalytics.nextClDecile = userState.clDecile;
    userActionAnalytics.nextSgDecile = userState.sgDecile;
    userActionAnalytics.nextClstrDecile = userState.clstrDecile;
    userActionAnalytics.nextWhisperingType = userState.whisperingType;
    userActionAnalytics.fcDecile = userState.fcDecile;

    userActionAnalytics.previousWeightedDecile = userState.previousWeightedDecile;
    userActionAnalytics.previousRgDecile = userState.previousRgDecile;
    userActionAnalytics.previousClDecile = userState.previousClDecile;
    userActionAnalytics.previousStDecile = userState.previousStDecile;
    userActionAnalytics.previousSgDecile = userState.previousSgDecile;
    userActionAnalytics.previousClstrDecile = userState.previousClstrDecile;
    userActionAnalytics.previousWhisperingType = userState.previousWhisperingType;

    userActionAnalytics.fcSource = userState.fcSource;
    userActionAnalytics.fcCampaign = userState.fcCampaign;
    userActionAnalytics.fcMedium = userState.fcMedium;
    userActionAnalytics.fcSessionWeightedDecile = userState.fcSessionWeightedDecile;
    userActionAnalytics.fcSessionId = userState.fcSessionId;
    userActionAnalytics.fcTimestamp = userState.fcTimestamp;

    userActionAnalytics.userBrowserType = userState.userBrowserType;
    userActionAnalytics.isBot = userState.isBot;
    userActionAnalytics.isConversion = userState.isConversion;
    if(userState.lastConversionTimestamp != null)
    {
        userActionAnalytics.lastConversionTimestamp = userState.lastConversionTimestamp;
    }
    else
    {
        userActionAnalytics.lastConversionTimestamp = "none";
    }
    
    if(userState.lastPredictionTimestamp != null)
    {
        userActionAnalytics.lastPredictionTimestamp = userState.lastPredictionTimestamp;
    }
    else
    {
        userActionAnalytics.lastPredictionTimestamp = "none";
    }
    
    UserActionAnalyticsCache.set(userActionAnalytics);
}

export function aiProcessUserActionCache()
{
    let counter = 0;
    while(counter < 10)
    {
        let action = UserActionCache.get();
        if(action != null)
        {
            aiCreateUserActionAnalytics(action);
            UserActionCache.delete(action.id);
        }
        counter += 1;
    }
}

export function aiProcessUserActionAnalytics()
{
    let userAnalyticsStorage = UserActionAnalyticsCache.getAll();
    let userPredictionsStorage = UserPredictionCache.getAll();

    let session = UserSessionProvider.get();
    let userState = UserStateProvider.get();

    if(userState.userId == null || userState.userId.includes(".") == false || userState.userId == "none")
    {
        userState.userId = GAService.getGaUserId();
        UserStateProvider.set(userState);
        return;
    }
    if(session.id == null || session.id.includes(".") == false || session.id == "none")
    {
        session.id = GAService.getGaSessionId();
        UserSessionProvider.set(session);
        return;
    }


        for (const [key, value] of Object.entries(userAnalyticsStorage)) 
        {
            try
            {
                BackendService.sendUserActionAnalytics(value, userState.domain);
                delete userAnalyticsStorage[key];
                UserActionAnalyticsCache.delete(key);
            }
            catch(ex)
            {
                console.log(ex);
            }
        }


    for (const [key, value] of Object.entries(userPredictionsStorage)) 
    {
        try
        {   
            let prediction = aiCreateUserPrediction(key, value);
            let pushStatus = aiUpdateUserStateWithPrediction(prediction);
            
            if(pushStatus == true)
            {
                aiPushPrediction(prediction.userActionType);
            }
            
            delete userPredictionsStorage[key];
            UserPredictionCache.delete(key);
        }
        catch(ex)
        {
            console.log(ex)
        }
    }
}
export function aiUpdateUserStateWithPrediction(prediction)
{
    let userState = UserStateProvider.get();
    let userSession = UserSessionProvider.get();
    let status = false;

    userState.previousWeightedDecile = userState.weightedDecile;
    userState.previousRgDecile = userState.rgDecile;
    userState.previousClDecile = userState.clDecile;
    userState.previousStDecile = userState.stDecile;
    userState.previousSgDecile = userState.sgDecile;
    userState.previousClstrDecile = userState.clstrDecile;
    userState.previousWhisperingType = userState.whisperingType;

    userState.previousUserType = userState.userType;
    
    userState.lastPredictionTimestamp = getUtcTimestamp();
    if(Number(userState.whisperingType) < Number(prediction.whisperingType))
    {
        userState.whisperingType = Number(prediction.whisperingType);
        console.log("whispering " + userState.whisperingType);
        status = true;
    }
    if(Number(userState.clDecile) < Number(prediction.clDecile))
    {
        userState.clDecile += 1;
        status = true;
    }
    if(Number(userState.clDecile) > 10)
    {
        userState.clDecile = 10;
    }
    if(Number(userState.rgDecile) < Number(prediction.rgDecile))
    {
        userState.rgDecile += 1;
        status = true;
    }
    if(Number(userState.rgDecile) > 10)
    {
        userState.rgDecile = 10;
    }
    if(Number(userState.stDecile) < Number(prediction.stDecile))
    {
        userState.stDecile += 1;
        status = true;
    }
    if(Number(userState.stDecile) > 10)
    {
        userState.stDecile = 10;
    }

    if(Number(userState.sgDecile) < Number(prediction.sgDecile))
    {
        userState.sgDecile += 1;
        status = true;
    }
    if(Number(userState.sgDecile) > 10)
    {
        userState.sgDecile = 10;
    }

    if(Number(userState.weightedDecile) < Number(prediction.weightedDecile))
    {
        userState.weightedDecile += 1;
        status = true;
    }
    if(Number(userState.weightedDecile) > 10)
    {
        userState.weightedDecile = 10;
    }

    if(Number(userState.clstrDecile) < Number(prediction.clstrDecile))
    {
        userState.clstrDecile += 1;
        status = true;
    }
    if(Number(userState.clstrDecile) > 10)
    {
        userState.clstrDecile = 10;
    }

    
    if(status == true)
    {
        userState.userType = aiCalculateUserType(userState.weightedDecile);
    }

    if(userState.fcSessionId == userSession.id && status == true)
    {
        userState.fcDecile = userState.weightedDecile;
        userState.fcSessionUserType = aiCalculateUserType(userState.weightedDecile);
    }

    UserStateProvider.set(userState);
    return status;
}

export function aiCalculateUserType(decile)
{
    let userDecile = Number(decile);
    if(userDecile < 3)
    {
        return "low";
    }
    if(userDecile >= 3 && userDecile < 8)
    {
        return "medium";
    }
    return "high";
}

export function aiCreateUserPrediction(id, value)
{
    let prediction = new UserPrediction();
    prediction.id = id;
    prediction.userActionType = value.userActionType;
    prediction.rgDecile = convertStringToNumber(value.rgDecile);
    prediction.clDecile = convertStringToNumber(value.clDecile);
    prediction.stDecile = convertStringToNumber(value.stDecile);
    prediction.sgDecile = convertStringToNumber(value.sgDecile);
    prediction.clstrDecile = convertStringToNumber(value.clstrDecile);
    prediction.weightedDecile = convertStringToNumber(value.weightedDecile);
    prediction.whisperingType = convertStringToNumber(value.whisperingType);
    return prediction;
}

export function aiPushPrediction(userActionType)
{
    let userState = UserStateProvider.get();
    let userPush = new UserPush();

    userPush.userId = userState.userId;
    userPush.userActionType = userActionType; 
    userPush.userActionTimestamp = getUtcTimestamp(); 
    userPush.userActionTimestampNumeric = getUtcTimestampNumeric();  

    userPush.fcUserSource = userState.fcSource;
    userPush.fcUserCampaign = userState.fcCampaign;
    userPush.fcUserMedium = userState.fcMedium;
    userPush.fcUserTimestamp = userState.fcTimestamp;

    userPush.userType = userState.userType;
    userPush.weightedDecile = userState.weightedDecile;
    userPush.stDecile = userState.stDecile;
    userPush.sgDecile = userState.sgDecile;
    userPush.rgDecile = userState.rgDecile;
    userPush.clDecile = userState.clDecile;
    userPush.clstrDecile = userState.clstrDecile;
    userPush.fcDecile = userState.fcDecile;
    userPush.whisperingType = userState.whisperingType;

    DataLayerService.send(userPush);
}